import React from "react";
import PropTypes from "prop-types";

import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";

import Box from "@material-ui/core/Box";

const { BRAND_NAME, SITE_NAME } = process.env;

import { adjective as proAdjective } from "@language/provider";
import { adjective as clientAdjective } from "@language/client";

const ProSplash = () => {
	const classes = useStyles("Pro");

	const { splash } = useConstants("ProPitchViewModel");

	return (
		<React.Fragment>
			<Box
				component="section"
				height={{ xs: "75vh", sm: "75vh" }}
				minHeight={{ xs: "75vh", sm: "75vh" }}
				display={"flex"}
				alignItems={"center"}
				padding={0}
				overflow={"hidden"}
				width={"100%"}
				position={"relative"}
				my={10}
			>
				<Box
					top={0}
					zIndex={"20"}
					left={0}
					margin={"0 auto"}
					position={"absolute"}
					width={"100%"}
				>
					<Box
						component={"img"}
						width={"100%"}
						src="https://s3.amazonaws.com/static.homeguide.com/assets/images/misc/bg-curve.svg"
					/>
				</Box>
				<Box
					display={"flex"}
					margin={"0 auto"}
					width={"100%"}
					height={"100%"}
					flexDirection={{ xs: "column-reverse", sm: "row" }}
				>
					<Box
						bgcolor={"#7dcfb6"}
						justifyContent={"center"}
						width={{ xs: "100%", sm: "40%" }}
						display={"flex"}
						alignItems={"center"}
						flexDirection={"column"}
						p={{ xs: "50px 0", sm: "0 30px" }}
					>
						<Box
							component={"h4"}
							fontSize={{ xs: 60, sm: 80 }}
							color={"#FFFFFF"}
							lineHeight={1}
							m={"0"}
						>
							{splash.title}
						</Box>
						<Box
							color={"#FFFFFF"}
							lineHeight={1.6}
							fontSize={18}
							textAlign={"center"}
							mt={8}
							maxWidth={350}
						>
							{splash.content}
						</Box>
					</Box>
					<Box display={"flex"} width={{ xs: "100%", sm: "60%" }}>
						<Box
							height={{ xs: "50vh", sm: "75vh" }}
							minHeight={{ xs: "50vh", sm: "75vh" }}
							alignSelf={"center"}
							width={{ xs: "50%", sm: "33%" }}
							borderLeft={{ xs: 0, sm: "10px solid #fff" }}
							overflow={"hidden"}
							position={"relative"}
							style={{
								backgroundImage: `url('${splash.img_1}')`,
								backgroundPosition: "50%",
								backgroundRepeat: "no-repeat",
								backgroundSize: "cover",
							}}
						>
							<Box
								left={10}
								bottom={10}
								position={"absolute"}
								bgcolor={"rgba(26,25,25,.5)"}
								p={2}
								fontSize={12}
								lineHeight={1}
								borderRadius={8}
								color={"#FFFFFF"}
							>
								Grace M. - Member
							</Box>
						</Box>

						<Box
							height={{ xs: "50vh", sm: "75vh" }}
							minHeight={{ xs: "50vh", sm: "75vh" }}
							alignSelf={"center"}
							width={{ xs: "50%", sm: "33%" }}
							borderLeft={"10px solid #fff"}
							overflow={"hidden"}
							position={"relative"}
							style={{
								backgroundImage: `url('${splash.img_2}')`,
								backgroundPosition: "50%",
								backgroundRepeat: "no-repeat",
								backgroundSize: "cover",
							}}
						>
							<Box
								left={10}
								bottom={10}
								position={"absolute"}
								bgcolor={"rgba(26,25,25,.5)"}
								p={2}
								fontSize={12}
								lineHeight={1}
								borderRadius={8}
								color={"#FFFFFF"}
							>
								David R. - Member
							</Box>
						</Box>

						<Box
							height={{ xs: "50vh", sm: "75vh" }}
							minHeight={{ xs: "50vh", sm: "75vh" }}
							alignSelf={"center"}
							width={{ xs: "50%", sm: "33%" }}
							borderLeft={"10px solid #fff"}
							overflow={"hidden"}
							position={"relative"}
							display={{ xs: "none", sm: "block" }}
							style={{
								backgroundImage: `url('${splash.img_3}')`,
								backgroundPosition: "50%",
								backgroundRepeat: "no-repeat",
								backgroundSize: "cover",
							}}
						>
							<Box
								left={10}
								bottom={10}
								position={"absolute"}
								bgcolor={"rgba(26,25,25,.5)"}
								p={2}
								fontSize={12}
								lineHeight={1}
								borderRadius={8}
								color={"#FFFFFF"}
							>
								Joanne P. - Member
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</React.Fragment>
	);
};

ProSplash.propTypes = {};
export default ProSplash;
